/**
 * @returns true if Certifications component should be hidden false otherwise. Consideres the dark mode.
 */
export function shouldCertificationsComponentBeHidden() {
  let hideComponent = false;
  try {  
    const shouldCertificationsComponentBeHiddenByDefault = window?.sfdcBase?.exp?.FEATURE_PROFILE_COMP_CERTIFICATIONS_HIDE === "true";
    const isDarkModeEnabled = window?.sfdcBase?.exp?.FEATURE_PROFILE_COMP_CERTIFICATIONS_DARK_MODE_ENABLED === "true";
  
    const params = new URLSearchParams(window.location.search);
    const isDarkModeBeingRequestedByCurrentUser = params.get("tbmeCerts") === "true";
  
    if (shouldCertificationsComponentBeHiddenByDefault) {
      if (isDarkModeEnabled && isDarkModeBeingRequestedByCurrentUser) {
        hideComponent = false;
      } else {
        hideComponent = true;
      }
    } else {
      hideComponent = false;
    }

  } catch (error) {
    console.error("error checking if certifications component should be hidden", error);
  }
  return hideComponent;
}

/**
 * @returns true if downtime banner is enabled false otherwise. By default, it only shows on private profile page.
 */
export function isDowntimeBannerEnabled() {
  return window?.sfdcBase?.exp?.FEATURE_PROFILE_BANNER_ENABLED === "true";
}


/**
 * @returns true if Hire Me feature is enabled false otherwise.
 */
export function isHireMeEnabled() {
  return window?.sfdcBase?.exp?.FEATURE_HIRE_ME === "true";
}

/**
 * @returns true if Career Marketplace feature is enabled false otherwise.
 */
export function isCareerMarketplaceEnabled() {
  return window?.sfdcBase?.exp?.FEATURE_CAREER_MARKET === "true";
}

/**
 * @returns true if Certification Item Actions Menu feature is enabled false otherwise.
 */
export function isCertificationItemActionsMenuEnabled() {
  return window?.sfdcBase?.exp?.FEATURE_CERTIFICATION_ITEM_ACTIONS_MENU === "true";
}

/**
 * @returns true if Accepted Answer Label feature is enabled false otherwise
 */
export function isAcceptedAnswersLabelEnabled() {
  return window?.sfdcBase?.exp?.FEATURE_ACCEPTED_ANSWERS_LABEL === "true";
}

/**
 * @returns true if we should hide the Profile Edit modal Settings banner false otherwise
 */
export function isHideProfileEditSettingsBannerEnabled() {
  return (
    window?.sfdcBase?.exp?.FEATURE_HIDE_PROFILE_EDIT_SETTINGS_BANNER === "true"
  );
}

export function areVirtualRegistrationFieldsEnabled() {
  return window?.sfdcBase?.exp?.FEATURE_VIRTUAL_REG_FIELDS === "true";
}

export function isTbmeSkillsComponentEnabled() {
  return window?.sfdcBase?.exp.FEATURE_TBME_SKILLS_COMPONENT === "true";
}

export function isIISUpdateProfileEnabled() {
  return window?.sfdcBase?.exp.FEATURE_IIS_UPDATE_PROFILE === "true";
}

export function isIISEventListenerEnabled() {
  return window?.sfdcBase?.exp.FEATURE_CHECK_IIS_EVENTS === "true";
}